import { defineMessages } from 'react-intl'

const scope =
  'procurify.platform.globalSearch.useFormatGlobalSearchIdentifierLabel'

export default defineMessages({
  invoiceNumberLabel: {
    id: `${scope}.invoiceNumberLabel`,
    defaultMessage: 'Invoice {invoiceNumber}',
  },
  externalPaymentMethodLabel: {
    id: `${scope}.externalPaymentMethodLabel`,
    defaultMessage: 'External',
  },
})
